if (! document.getElementById("mocha")) { document.write("<div id=\"mocha\"></div>"); }

require("!style!css!mocha/mocha.css");
require("!script!mocha/mocha.js");



/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha-loader/web.js
 ** module id = 1
 ** module chunks = 0
 **/